import { useGlobalContext } from '../context/GlobalState'
import { usePlanPermissions } from '../hooks/usePlanPermissions'
import Layout from '../components/layouts'
import TabsFacturacion from '../components/modules/views/dashboard/Facturacion/TabsFacturacion'
import FacturacionOnboarding from '../components/modules/views/dashboard/Facturacion/components/FacturacionOnboarding'

export default function Facturacion() {
  const { currentBusiness } = useGlobalContext()
  const { hasPermission, hasPlan, subscriptionExpired } = usePlanPermissions()

  const hasBillingAccess =
    hasPlan && !subscriptionExpired && hasPermission('allowIntelligentBilling')
  const hasBillingCredentials = Boolean(currentBusiness?.tokenFacturas)

  return (
    <Layout className='px-0 sm:px-2 md:px-3 xl:px-4'>
      {hasBillingAccess && hasBillingCredentials ? (
        <TabsFacturacion />
      ) : (
        <FacturacionOnboarding isActivated={hasBillingAccess} />
      )}
    </Layout>
  )
}
